import { createFileRoute } from '@tanstack/react-router'

import { DuplicateInstrumentsScreen } from './-components/duplicate-instruments-screen.tsx'

export const Route = createFileRoute('/transaction-monitoring/duplicate-cards')(
  {
    component: () => <DuplicateInstrumentsScreen page="duplicate-cards" />
  }
)
